import React from 'react';
import { AccountType, Role, User } from 'csa-ui/src/lib/api/api-types';
import { Chip } from '@mui/material';

interface IProps {
  user: User;
  viewerRole: Role;
}

const cssClasses = {
  chip: {
    margin: '2px',
  },
};

export function AccountChips(props: IProps) {
  const { role, accountType, isTest, disabled } = props.user;
  const { viewerRole } = props;

  const acctType = (type: AccountType) => {
    switch (type) {
      case AccountType.NORMAL:
        return null;
      case AccountType.SINGLE_USE:
        return <Chip size="small" label="Singe Use" sx={cssClasses.chip} />;
      case AccountType.SINGLE_USE_INVITE:
        return <Chip size="small" label="Singe Use Invite" sx={cssClasses.chip} />;
      default:
        console.error('Unhandled account type', type);
        return null;
    }
  };

  const acctRole = (role: Role) => {
    switch (role) {
      case Role.ADMIN:
        return <Chip size="small" label="Admin" sx={cssClasses.chip} />;
      case Role.STAFF:
        return <Chip size="small" label="Staff" sx={cssClasses.chip} />;
      case Role.USER:
        return <Chip size="small" label="User" sx={cssClasses.chip} />;
      default:
        console.error('Unhandled use role', role);
        return null;
    }
  };

  return (
    <>
      {acctRole(role)}
      {isTest && <Chip size="small" label="Test User" sx={cssClasses.chip} />}
      {acctType(accountType)}
      {disabled && <Chip size="small" color="error" label="Disabled" />}
    </>
  );
}
